<template>
<section id="as-video" class="as-video" :style="{opacity:showVideo?1:0,zIndex:showVideo?1000:-1000}">
  <div class="bg"></div>
  <div class="video">
    <video :src="video" controls></video>
    <a class="close" @click="playVideo(false)">x</a>
  </div>
</section>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      firstplay: false,
      showVideo: false
    }
  },
  computed: {
    video () {
      return this.firstplay ? 'https://static001.geekbang.org/static/asbj2019/20190806AS.mp4' : ''
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    playVideo (play = true) {
      var video = window.document.querySelector('#as-video video')
      if (play) {
        this.firstplay = true
        this.showVideo = true
        setTimeout(() => {
          video.play()
        }, 100)
      } else {
        this.showVideo = false
        video.pause()
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.as-video
  position: fixed
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  z-index: -1000
  opacity: 0
  transition: opacity 0.4s
  .bg
    position: absolute
    left: 0
    right: 0
    width: 100%
    height: 100%
    background: #000
    opacity: 0.7
    z-index: -1
  .video
    width: 943px
    height: 530px
    position: relative
    background: #000
    video
      width: 100%
      height: 100%
    a.close
      cursor: pointer
      position: absolute
      $size: 30px
      top: -$size/2
      right: -$size/2
      top: 0
      right: -$size
      width: $size
      height: $size
      background: #eee
      font-style: normal
      font-size: 25px
      color: #333
      display: flex; justify-content: center;align-items: center
      &:hover
        background: #fff
</style>
